import { render, staticRenderFns } from "./ExportShipmentIcon.vue?vue&type=template&id=3dafc1c8"
import script from "./ExportShipmentIcon.vue?vue&type=script&lang=js"
export * from "./ExportShipmentIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports